import type { ClientCountryDetails } from '@dfg/brahma-types';
import { ContextAction } from '../types';
import type { CurrentVRCountryAction } from './types';

export const currentVRCountryInitial: ClientCountryDetails = {
  name: ''
};

export const currentVRCountryReducer = (
  state: ClientCountryDetails,
  action: CurrentVRCountryAction
): ClientCountryDetails => {
  switch (action.type) {
    case ContextAction.setCountryData:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
